import Lightbox from "./Lightbox";

export default class Gallery extends Lightbox {

    constructor(element) {
        super(element);

        this.$items = null;
        this.$counter = null;

        this.$previousSlideHandler = null;
        this.$nextSlideHandler = null;

        this.contentLoadedListener = null;

        this.lightbox = false;
        this.counterClickListener = null;

        this.hammerJs = null;

        this.init();
    }

    init() {

        // init lightbox
        super.init();

        const mySelf = this;
        this.hammerJs = Hammer(this.element);

        this.$items = this.$element.find('[data-gallery-item="true"]');
        this.$counter = this.$element.find('[data-type="gallery-counter"]');

        this.$previousSlideHandler = this.$element.find('[data-gallery-handler="previous"]');
        this.$nextSlideHandler = this.$element.find('[data-gallery-handler="next"]');

        this.showPreviousSlideListener = function (event) {
            mySelf.showGalleryslide(-1);
            if (event.type == "click") {
                event.stopPropagation();
            }
        }

        this.contentLoadedListener = function () {
            mySelf.initGalleryItems();
        }

        $(document).on('content:loaded', this.contentLoadedListener);

        this.showNextSlideListener = function (event) {
            mySelf.showGalleryslide(1);
            if (event.type == "click") {
                event.stopPropagation();
            }
        }

        let lightbox = this.$element.attr('data-lightbox');
        if (lightbox != undefined && lightbox) {
            this.lightbox = true;
            this.$element.on('click', this.openLightboxListener);

            // clicks abfangen, falls ein preloader im focus ist (workaround)
            this.counterClickListener = function (event) {
                const $activeItemDataType = mySelf.$items.filter('.active').attr('data-type');
                if ($activeItemDataType == "videopreloader" || $activeItemDataType == "imagepreloader") {
                    event.stopPropagation();
                }
            };
            this.$counter.on('click', this.counterClickListener);
        }


        if (this.$items != null && this.$items.length > 1) {

            // vorherigen slide anzeigen
            this.$previousSlideHandler.on('click', this.showPreviousSlideListener);
            // nächsten slide anzeigen

            this.$nextSlideHandler.on('click', this.showNextSlideListener);

            // Swipe
            this.hammerJs.on('swiperight', this.showPreviousSlideListener);
            this.hammerJs.on('swipeleft', this.showNextSlideListener);

            const $nextItem = this.$items.filter('.active').next('[data-gallery-item="true"]');
            if ($nextItem.length > 0 && $nextItem != undefined) {

                this.$nextSlideHandler.removeClass('hidden');

                setTimeout(function () {
                    mySelf.preloadImage($nextItem);
                }, 400)

            } else {
                this.$nextSlideHandler.addClass('hidden');
            }

            const $previousItem = this.$items.filter('.active').prev('[data-gallery-item="true"]');
            if ($previousItem.length > 0 && $previousItem != undefined) {

                this.$previousSlideHandler.removeClass('hidden');

                setTimeout(function () {
                    mySelf.preloadImage($previousItem);
                }, 400)

            } else {
                this.$previousSlideHandler.addClass('hidden');
            }

            // Anzahl anzeigen
            this.$counter.children('[data-type="gallery-items-count"]').text(this.$items.length);

            const $activeItem = this.$items.filter('.active');
            const currentPosition = this.$items.index($activeItem) + 1;

            if (currentPosition > 1) {
                this.$counter.children('[data-type="gallery-current-position"]').text(currentPosition);
            }
        }
    }

    showGalleryslide(offset) {

        $(document).trigger('allvideo:stop');

        const $activeItem = this.$items.filter('.active');

        const currentIndex = this.$items.index($activeItem);
        const newIndex = currentIndex + offset;
        const maxIndex = this.$items.length - 1;
        let currentGalleryPosition = newIndex + 1;
        let nextItem = null;

        if (maxIndex < 1 || newIndex < 0) {
            return;
        }

        // counter, min position
        if (currentGalleryPosition < 1) {
            currentGalleryPosition = 1;
        }

        // counter, max position
        if (currentGalleryPosition > this.$items.length) {
            currentGalleryPosition = this.$items.length;
        }

        if (newIndex >= 0 && newIndex <= maxIndex) {
            $activeItem.removeClass('active');

            nextItem = this.$items.get(newIndex);
            $(nextItem).addClass('active');
        }

        if (nextItem == undefined) {
            return;
        }

        // sichtbarkeit next handler
        if (newIndex >= maxIndex) {
            this.$nextSlideHandler.addClass('hidden');
        } else {
            this.$nextSlideHandler.removeClass('hidden');
        }

        // sichtbarkeit previous handler
        if (newIndex > 0) {
            this.$previousSlideHandler.removeClass('hidden');
        } else {
            this.$previousSlideHandler.addClass('hidden');
        }

        this.$counter.children('[data-type="gallery-current-position"]').text(currentGalleryPosition);

        // nächste bild vorladen (für resize event nötig)
        if (newIndex <= maxIndex && newIndex >= 0) {
            let preloadSlide = this.$items.get(newIndex);
            if (preloadSlide != undefined) {
                this.preloadImage($(preloadSlide));
            }
        }

        // übernächste bild vorladen
        let preloadIndex = newIndex + offset;
        if (preloadIndex <= maxIndex && preloadIndex >= 0) {
            let preloadSlide = this.$items.get(preloadIndex);
            if (preloadSlide != undefined) {
                this.preloadImage($(preloadSlide));
            }
        }
    }


    initGalleryItems() {
        if (this.$element != undefined) { // todo prüfen
            this.$items = this.$element.find('[data-gallery-item="true"]');
        }
    }

    preloadImage(item) {

        // optimierungsbedarf, this.$element sollte nicht undefined sein können
        if (this.$element == undefined) {
            return;
        }

        let width = this.$element.innerWidth();
        let quality = 1;

        // optimierungsbedarf
        // if (this.$element.parent().attr('data-type') == 'lightbox-content') {
        //     quality = 4;
        // }

        if (item.attr('data-type') != "autosizeimage") {
            item = item.find('[data-type="autosizeimage"]');
        }

        $(item).trigger('content:preload', {
            preloadwidth: width,
            quality: quality
        });
    }

    loadLightboxContent() {

        const mySelf = this;
        const $items = this.$element.find('[data-gallery-item="true"]');
        const $gallery = this.templatesWorker.getTemplate('gallery-js-template');

        $($items).each(function (key, item) {

            let $item = $(item);
            let $template = null;
            let dataType = $item.attr('data-type')
            let isActive = $item.hasClass('active');

            if (dataType == 'autosizeimage') {
                let imageData = {
                    width: $item.attr('data-width'),
                    height: $item.attr('data-height'),
                    aspectratio: $item.attr('data-aspectratio'),
                    imgUrl: $item.attr('data-img-url'),
                    customLoad: !isActive,
                };

                $template = mySelf.templatesWorker.loadAutoSizeImageTemplate(
                    imageData,
                    1,
                    false,
                    false,
                    true,
                    isActive,
                    true
                );

            } else if (dataType == 'videoplayer') {

                const videoUrl = $item.attr('data-video-url');
                let autoplay = false;
                let $autoSizeImage = $item.find('[data-type="autosizeimage"]');
                let imageData = {
                    width: $autoSizeImage.attr('data-width'),
                    height: $autoSizeImage.attr('data-height'),
                    aspectratio: $autoSizeImage.attr('data-aspectratio'),
                    imgUrl: $autoSizeImage.attr('data-img-url'),
                    customLoad: !isActive,
                };

                if (isActive) {
                    autoplay = true;
                }

                $template = mySelf.templatesWorker.loadVideoplayerTemplate(
                    videoUrl,
                    imageData,
                    1,
                    false,
                    false,
                    true,
                    isActive,
                    autoplay,
                    false,
                    true
                );
            }

            if ($template != null) {
                $gallery.append($template);
            }
        });

        return $gallery;
    }

    destroyListener() {
        super.destroyListener();

        // desktop, slide via click
        this.$previousSlideHandler.off('click', this.showPreviousSlideListener);
        this.$nextSlideHandler.off('click', this.showPreviousSlideListener);

        // mobile, slide via swipe
        this.hammerJs.off('swiperight', this.showPreviousSlideListener);
        this.hammerJs.off('swipeleft', this.showNextSlideListener);

        this.$counter.off('click', this.counterClickListener);
    }
}